/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Update Account Request Body Schema
 * @export
 * @interface UpdateAccountRequest
 */
export interface UpdateAccountRequest {
    /**
     * Account Username
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    username?: string;
    /**
     * Account Email
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    email?: string;
    /**
     * Account Given Name
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    givenName?: string;
    /**
     * Account Family Name
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    familyName?: string;
    /**
     * Account Phone Number
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    phoneNumber?: string;
    /**
     * Hide Email From Members
     * @type {boolean}
     * @memberof UpdateAccountRequest
     */
    hideEmailFromMembers?: boolean;
    /**
     * Hide Phone Number From Members
     * @type {boolean}
     * @memberof UpdateAccountRequest
     */
    hidePhoneFromMembers?: boolean;
}

/**
 * Check if a given object implements the UpdateAccountRequest interface.
 */
export function instanceOfUpdateAccountRequest(value: object): value is UpdateAccountRequest {
    return true;
}

export function UpdateAccountRequestFromJSON(json: any): UpdateAccountRequest {
    return UpdateAccountRequestFromJSONTyped(json, false);
}

export function UpdateAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'givenName': json['given_name'] == null ? undefined : json['given_name'],
        'familyName': json['family_name'] == null ? undefined : json['family_name'],
        'phoneNumber': json['phone_number'] == null ? undefined : json['phone_number'],
        'hideEmailFromMembers': json['hide_email_from_members'] == null ? undefined : json['hide_email_from_members'],
        'hidePhoneFromMembers': json['hide_phone_from_members'] == null ? undefined : json['hide_phone_from_members'],
    };
}

export function UpdateAccountRequestToJSON(value?: UpdateAccountRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'username': value['username'],
        'email': value['email'],
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'phone_number': value['phoneNumber'],
        'hide_email_from_members': value['hideEmailFromMembers'],
        'hide_phone_from_members': value['hidePhoneFromMembers'],
    };
}

